



















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { PrintableDocument } from '@/api/model/printable-document'
import { PrintableDocumentAPI } from '@/api/backend-client'

@Component
export default class CompanySettingsEmmaDirectMailPrintableDocumentsEdit extends Vue {
    @Prop({ required: true }) readonly printableDocumentId!: string
    printableDocument: PrintableDocument = null
    editingPrintableDocument: PrintableDocument = null
    editingPrintableDocumentFile: File = null
    loading: boolean = false
    saving: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.printableDocument = await PrintableDocumentAPI.get(this.printableDocumentId)
        this.editingPrintableDocument = cloneDeep(this.printableDocument)
        this.loading = false
    }

    async save(): Promise<void> {
        this.saving = true
        if (this.editingPrintableDocumentFile) {
            this.printableDocument = await PrintableDocumentAPI.updateWithFile(
                this.editingPrintableDocument.id,
                this.editingPrintableDocument,
                this.editingPrintableDocumentFile,
            )
        } else {
            this.printableDocument = await PrintableDocumentAPI.update(
                this.editingPrintableDocument.id,
                this.editingPrintableDocument,
            )
        }
        this.saving = false
        await this.goToList()
    }

    async cancel(): Promise<void> {
        await this.goToList()
    }

    async goToList(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_emma_direct_mail_printable_documents_list',
        })
    }

    get productIdOptions() {
        const productIds = [
            'kaart_dubbel_10x10',
            'kaart_dubbel_14x14',
            'kaart_dubbel_a5_sta',
            'kaart_dubbel_a6_sta',
            'kaart_enkel_a5_lig',
            'kaart_enkel_a6_lig',
            'kaart_enkel_a6_sta',
            'boek_ge_a4_sta',
            'boek_ge_a5_sta',
            'magazine_21x21',
            'magazine_a4_lig',
            'magazine_a4_sta',
            'magazine_a5_lig',
            'magazine_a5_sta',
        ]

        return productIds.map((productId: string) => {
            return {
                label: this.$t('company_settings.emma_direct_mail.printable_documents.field.productIds.' + productId),
                value: productId,
            }
        })
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }
}
